import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';
import { TradeBenefitsYourFirmRep } from './TradeBenefitsYourFirmRep.tsx';
import { TradeBenefitsYourFirmMembers } from './TradeBenefitsYourFirmMembers.tsx';

import { type TradeBenefitsYourFirm_viewer$key } from './__generated__/TradeBenefitsYourFirm_viewer.graphql.ts';

import styles from './TradeBenefitsYourFirm.scss';
import dibsCss from 'dibs-css';

const viewerFragment = graphql`
    fragment TradeBenefitsYourFirm_viewer on Viewer {
        ...TradeBenefitsYourFirmRep_viewer
        ...TradeBenefitsYourFirmMembers_viewer
    }
`;

const TradeBenefitsYourFirm: FC<{
    viewer: TradeBenefitsYourFirm_viewer$key | null | undefined;
}> = ({ viewer: viewerRef }) => {
    const viewer = useFragment(viewerFragment, viewerRef);

    if (!viewer) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            <HeadingLevel>
                {Heading => (
                    <Heading className={classnames(dibsCss.sassyFontHeaderLarge, dibsCss.m0)}>
                        <FormattedMessage
                            id="abt.TradeBenefitsYourFirm.title"
                            defaultMessage="Your Firm <italic>At-a-Glance</italic>"
                            values={{
                                italic: content => (
                                    <span className={dibsCss.sassyFontHeaderLargeItalic}>
                                        {content}
                                    </span>
                                ),
                            }}
                        />
                    </Heading>
                )}
            </HeadingLevel>
            <div className={dibsCss.mtMedium}>
                <TradeBenefitsYourFirmRep viewer={viewer} />
                <TradeBenefitsYourFirmMembers viewer={viewer} />
            </div>
        </div>
    );
};

export { TradeBenefitsYourFirm };
